import $ from 'jquery';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import './index.scss';
import './iconfont';
import TEMPLATE from './template';



class ImageCropper {
	constructor(options = {}) {
		this.options = options;
		this.CROPPER = null;
		this.image = null;
		this.init();
	}

	init() {
		console.log(this.options);

		this.build();
	}
	
	remove() {

	}

	build() {
		const body = document.body || document.documentElement;
		const template = document.createElement('div');
		template.innerHTML = TEMPLATE;

		const imageBox = template.querySelector('.layercropb-imgbox');
		const previewBox = template.querySelector('.previewBox');
		previewBox.style.height = this.options.height * 120 / this.options.width + 'px';

		const btnClose = template.querySelectorAll('.btn-close');
		const btnRotateLeft = template.querySelector('.btn-rotate-left');
		const btnRotateRight = template.querySelector('.btn-rotate-right');
		const btnZoomIn = template.querySelector('.btn-zoom-in');
		const btnZoomOut = template.querySelector('.btn-zoom-out');
		const btnReset = template.querySelector('.btn-reset');
		const btnDone = template.querySelector('.btn-done');

		const image = document.createElement('img');
		image.src = this.options.imgurl;

		imageBox.appendChild(image);

		body.appendChild(template);

		this.CROPPER = new Cropper(image, {
			aspectRatio: this.options.width / this.options.height,
			preview: [previewBox]
		});

		const _this = this;
		btnRotateLeft.addEventListener('click', function(){
			_this.CROPPER.rotate(-45);
		});
		btnRotateRight.addEventListener('click', function(){
			_this.CROPPER.rotate(45);
		})
		btnZoomIn.addEventListener('click', function(){
			_this.CROPPER.zoom(-.1);
		});
		btnZoomOut.addEventListener('click', function(){
			_this.CROPPER.zoom(.1);
		});
		btnReset.addEventListener('click', function(){
			_this.CROPPER.reset();
		});
		btnClose.forEach(b => {
			b.addEventListener('click', () => {
				_this.CROPPER.destroy();
				body.removeChild(template);
			});
		});
		btnDone.addEventListener('click', function(){
			_this.CROPPER.getCroppedCanvas({
				minWidth: _this.options.width,
                minHeight: _this.options.height,
                maxWidth: _this.options.width*2,
                maxHeight: _this.options.height*2,
                fillColor: '#fff',
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high',
            }).toBlob((blob) => {
                // console.log(blob);
				_this.options.done(blob);
				_this.CROPPER.destroy();
				body.removeChild(template);
            }, 'image/jpeg');
		});
	}
}


// const ImageCropper = (imgurl) => {
// 	console.log('image cropper');
// 	createLayer(imgurl);

// 	const image = document.getElementById('cropImg');
	
// }

// export { ImageCropper as default }

export default ImageCropper;